// extracted by mini-css-extract-plugin
module.exports = {"artGalleryItem":"ArtGalleryItem_artGalleryItem__3M-Di","image":"ArtGalleryItem_image__Hjem7","text":"ArtGalleryItem_text__25FJM","img":"ArtGalleryItem_img__3IyQd"};